"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UILoadingOverlay = _interopRequireDefault(require("UIComponents/loading/UILoadingOverlay"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("composer-plugins/lib/constants");

var _default = (0, _createReactClass.default)({
  displayName: "VideoComponent",
  propTypes: {
    showLoadingOverlay: _propTypes.default.bool.isRequired,
    showActionButtons: _propTypes.default.bool,
    videoFound: _propTypes.default.bool.isRequired,
    vidyardURL: _propTypes.default.string,
    nativeURL: _propTypes.default.string,
    videoRef: _propTypes.default.func,
    onVideoLoad: _propTypes.default.func,
    onMouseEnter: _propTypes.default.func,
    onMouseLeave: _propTypes.default.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      showActionButtons: false
    };
  },
  renderLoadingOverlay: function renderLoadingOverlay() {
    if (!this.props.showLoadingOverlay) {
      return null;
    }

    return _react.default.createElement(_UILoadingOverlay.default, {
      contextual: true
    });
  },
  renderVideoNotFoundError: function renderVideoNotFoundError() {
    if (this.props.videoFound) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "video-not-available"
    }, _react.default.createElement("div", {
      className: "info-wrapper"
    }, _react.default.createElement(_UIIcon.default, {
      className: "missing-icon",
      name: "ghost",
      size: "large"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.videoPlugin.info.notFound"
    })));
  },
  renderVideo: function renderVideo() {
    var _this$props = this.props,
        vidyardURL = _this$props.vidyardURL,
        nativeURL = _this$props.nativeURL,
        videoRef = _this$props.videoRef,
        onVideoLoad = _this$props.onVideoLoad;

    if (!vidyardURL && !nativeURL) {
      return null;
    }

    if (!vidyardURL && nativeURL) {
      return _react.default.createElement("video", {
        controls: true,
        ref: videoRef,
        src: nativeURL,
        width: "640",
        height: "360",
        scrolling: "no",
        frameBorder: "0",
        allowTransparency: true,
        allowFullScreen: true
      });
    }

    return _react.default.createElement("iframe", {
      ref: videoRef,
      src: vidyardURL,
      width: "640",
      height: "360",
      scrolling: "no",
      frameBorder: "0",
      allowTransparency: true,
      allowFullScreen: true,
      onLoad: onVideoLoad
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        showActionButtons = _this$props2.showActionButtons,
        onMouseEnter = _this$props2.onMouseEnter,
        onMouseLeave = _this$props2.onMouseLeave;
    var classNames = (0, _classnames.default)(_constants.VIDEO_COMPONENT_CLASSNAME, {
      active: showActionButtons
    });
    return _react.default.createElement("div", {
      className: classNames,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, this.renderVideoNotFoundError(), this.renderVideo(), this.renderLoadingOverlay());
  }
});

exports.default = _default;
module.exports = exports.default;